import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Amplify, ResourcesConfig } from 'aws-amplify';
import config from './config.js';

const domain = `${config.application_name}-${config.environment_name}.auth.${config.AWS_REGION}.amazoncognito.com`;

const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: config.AWS_COGNITO_CLIENT_ID,
      userPoolId: config.AWS_COGNITO_USER_POOL_ID,
      // Optional. Only needed for AWS credential exchange (e.g. direct S3
      // access); user-pool auth does not use it. Undefined when unset.
      identityPoolId: config.AWS_COGNITO_IDENTITY_POOL_ID,
      loginWith: {
        oauth: {
          domain,
          scopes: [
            'openid',
            'email',
            'profile',
            `API-Integration/${config.application_name}-${config.environment_name}-api-integration`,
          ],
          redirectSignIn: [
            `${config.APP_DOMAIN_ENDPOINT}/auth/callback`,
            'http://localhost:4200/auth/callback',
          ],
          redirectSignOut: [
            `${config.APP_DOMAIN_ENDPOINT}/auth/login`,
            'http://localhost:4200/auth/login',
          ],
          responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
};

// Amplify must be configured before the application bootstraps. Otherwise any
// component or interceptor that calls fetchAuthSession() during startup runs
// against an unconfigured Amplify instance, fails, and - before the interceptor
// was hardened - dispatched the request with no Authorization header.
Amplify.configure(awsConfig);

if (!config.API_GATEWAY_ENDPOINT) {
  // A blank endpoint makes every API call resolve against the app's own origin
  // and 404 or 403. Surface it loudly instead of failing opaquely at runtime.
  console.error(
    'API_GATEWAY_ENDPOINT is not configured. The build did not receive the ' +
      'API_GATEWAY_ENDPOINT environment variable.'
  );
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
